export * from './consultation-types-detail.service';
